module.exports = __webpack_public_path__ + "img/flag_spanish.14c0372a.png";